import styled from "@emotion/styled";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { Typography } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changeSubCategory } from "../../redux/slices/category";

const BackArrow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleActiveSubCategory = (id) => {
    dispatch(changeSubCategory(id));
  };
  return (
    <StyledBackPage
      className="arrow"
      onClick={(e) => {
        navigate(-1);
        handleActiveSubCategory(undefined);
      }}
    >
      <ArrowBackRoundedIcon color="secondary" />
      <Typography variant="text" component={"a"} color="primary">
        Retrocede
      </Typography>
    </StyledBackPage>
  );
};

export default BackArrow;

const StyledBackPage = styled.div`
  display: flex;
  :hover {
    text-decoration: underline;
  }
  gap: 5px;
  align-items: center;
  cursor: pointer;
  width: max-content;
  > a {
    text-decoration: none;
  }
`;
